import { Typography } from 'design-system/src/components/Typography/Typography';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  overflow: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export function FormInfo({ formName, children }: { formName: string; children: React.ReactNode }) {
  return (
    <Container>
      <Typography styledAs="bodyLargeSpaceGrotesk" weight={700}>
        {formName}
      </Typography>
      {children}
    </Container>
  );
}
